export const environment = {
  production: true,
  baseApiSpeedpresta: "https://api.speedpresta.com/api/v1/",
  siteUrl: "SITE/RETRIEVE_ALL_FROM_KEY",
  siteCreateUrl: "SITE/CREATE",
  siteUpdateUrl: "SITE/UPDATE_ALL",
  siteDeleteUrl: "SITE/DELETE",
  siteRetrieveUrl: "SITE/RETRIEVE_FROM_KEY",
  relationSiteClientUrl: "RELATION-SITE-CLIENT/RETRIEVE_ALL_FROM_KEY",
  relationSiteClientCreateUrl: "RELATION-SITE-CLIENT/CREATE",
  relationSiteClientUpdateUrl: "RELATION-SITE-CLIENT/UPDATE_ALL",
  relationSiteClientDeleteUrl: "RELATION-SITE-CLIENT/DELETE",
  customerUrl: "CUSTOMERS/RETRIEVE_ALL_FROM_KEY",
  customerRetrieveUrl: "CUSTOMERS/RETRIEVE_FROM_KEY",
  externaleAuthUrl: "platform.wariflow.com/platform/wariflow/",
  apiUrl: "https://app.wariflow.com/api/v1/gestion-site",
};
